import {filter, map, startWith, shareReplay} from 'rxjs/operators';
import {wwData$} from './worker-data';
import type {ContractMarket} from '@px/ws-data';

interface Msg<T> {
  type: string;
  action?: 'replace' | 'update' | 'remove';
  data?: T;
  [index: string]: any;
}

export const contractMarketsCache$ = wwData$.pipe(
  filter((o: Msg<any>) => o.type === 'market24h-contract'),
  map((o: Msg<any>): Map<string, ContractMarket> => o.data),
  filter(Boolean),
  startWith(new Map<string, ContractMarket>()),
  shareReplay(1)
);
